/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { PropsWithChildren } from "react";
import { Box, Text } from "@nordcloud/gnui";

export function EstateContainer({
  children: estateContent,
}: PropsWithChildren<{}>) {
  return (
    <Box>
      <Text weight="medium">Estate Records</Text>
      {estateContent}
    </Box>
  );
}
